import { TabSelected } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardTypes';
import { TicketsTabTrip } from 'Services/Api/_HumanWritten/BookingWizardDataService';

/**
 * A walk-on booking on a vessel that does not take walk-ons (`FerryEntity.WalkOnBookingsDisabled`).
 *
 * <p>A different thing from the sailing being closed to passengers, and said differently. Closed
 * is a state of the sailing that staff set and may lift, and its explanation is "contact staff to
 * book". This is a fact about the vessel: the passenger capacity is there and in use, by people in
 * vehicles, and no amount of asking will put a walk-on on it. So the card keeps its capacities —
 * the passenger one marked red, carrying this reason — rather than replacing them with `CLOSED`.</p>
 *
 * <p>Only where it is the reason. A sailing also closed to passengers is closed, and says so.</p>
 */
export function isWalkOnNotOffered(trip: TicketsTabTrip, tabSelected: TabSelected) {
	return tabSelected === 'passenger' && trip.walkOnBookingsDisabled === true && !trip.passengerBookingsClosed;
}

export const walkOnNotOfferedMessage = {
	id: 'trip-option__walk-on-not-offered__label',
	defaultMessage: "This vessel doesn't offer walk-on bookings",
};
